// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"5bf315ab","129":"5ca3ee93","162":"7bd62b31","171":"fcf25869","404":"fef4ab7c","453":"8cec9fb2","697":"2191caa0","698":"c10b0396","699":"51916cb0","837":"8a061ed6","873":"0e5aa0b2","983":"cc4d3655"}[chunkId] + ".chunk.js";
};